import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from '../assets/loading-animation.json';// Replace with your actual Lottie JSON file
import './Loading.css';

const Loading = () => {
  const defaultOptions = {
    loop: true,  // Make the animation loop
    autoplay: true,  // Autoplay the animation
    animationData: loadingAnimation,  // Replace with your Lottie JSON data
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="loading-container">
      <div className="overlay"></div>
      <Lottie options={defaultOptions} height={150} width={150} />
    </div>
  );
};

export default Loading;
